import { render } from "./ErrorPage.vue?vue&type=template&id=666625d4"
const script = {}

import exportComponent from "/root/driver-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__